import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { AppShell } from '@/components/layout/AppShell';
import { useAuthStore } from '@/stores/auth';
import { isExpired, isMfaVerified } from '@/lib/jwt';
import { bootstrapSession } from '@/api/client';

export const Route = createFileRoute('/_authed')({
  beforeLoad: async () => {
    await bootstrapSession();
    const { status, accessToken } = useAuthStore.getState();
    if (status === 'anonymous') throw redirect({ to: '/login' });
    if (status === 'pre_mfa' || status === 'needs_mfa') throw redirect({ to: '/mfa' });
    // Defensive: ensure the in-memory access token is what we think it is.
    if (!accessToken || !isMfaVerified(accessToken) || isExpired(accessToken)) {
      throw redirect({ to: '/mfa' });
    }
  },
  component: AuthedLayout,
});

function AuthedLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
